import { render, staticRenderFns } from "./PublicationSingle.vue?vue&type=template&id=3fac4708&"
import script from "./PublicationSingle.vue?vue&type=script&lang=js&"
export * from "./PublicationSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports